
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"a","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M61.3,16.89s-.01-.03-.02-.05c-.05-.15-.11-.29-.18-.43-.02-.03-.03-.07-.04-.1,0-.02-.02-.03-.03-.05-.47-.91-1.19-1.68-2.12-2.19L34.51.65c-1.57-.86-3.44-.86-5.01,0l-11.73,6.45s-.03.02-.04.02l-12.63,6.95c-.92.51-1.65,1.28-2.11,2.19-.01.02-.03.03-.04.05-.02.04-.03.08-.05.11-.06.13-.12.27-.17.41,0,.02-.02.04-.02.07-.2.56-.32,1.16-.32,1.77v26.67c0,1.91,1.04,3.67,2.71,4.59l24.4,13.43c.78.43,1.65.65,2.51.65s1.72-.22,2.51-.65l24.4-13.43c1.67-.92,2.71-2.68,2.71-4.6v-26.66c0-.62-.12-1.21-.32-1.77ZM32,6.14l20.65,11.36-6.63,3.64-20.65-11.36,6.63-3.65ZM32,28.86l-20.65-11.36,7.77-4.28,20.65,11.36-7.77,4.28ZM8.38,22.74l20.62,11.34v22.12l-20.62-11.35v-22.12ZM35,56.21v-22.12l7.31-4.02v8.62c0,1.66,1.34,3.01,3,3.01s3-1.35,3-3.01v-11.92l7.31-4.02v22.12l-20.62,11.35Z"}})])
          )
        }
      }
    